export const updateUrlParams = (path: string, theme: string): void => {
  // const sessionStorageCustomer = window.sessionStorage.getItem('kubra-customer');
  // const urlParams = sessionStorageCustomer === null ? '' : `?${sessionStorageCustomer}`;

  window.history.pushState('kubra-customer', 'kubra-customer', `${path}${theme}`);
};

export default updateUrlParams;
